import {BaseModel} from '@models/base-model';

export class MetaPagination extends BaseModel {
    totalCount: number;
    pageCount: number;
    currentPage: number;
    perPage: number;
}
